import {
  isAllowPreviewAudio,
  isAllowPreviewImage,
  isAllowPreviewVideo,
} from '@/renderer/scripts/composition/allowPreview';
import { FileType } from '@/renderer/components/drawer/compositions/fileType';
import { SMH } from '@/renderer/scripts/smh';
function getFileType(file: SMH.SpaceFileItemData) {
  if (file.previewByDoc) return FileType.Document;
  if (isAllowPreviewImage(file.name)) return FileType.Picture;
  if (isAllowPreviewAudio(file.name)) return FileType.Audio;
  if (isAllowPreviewVideo(file.name)) return FileType.Video;
  return FileType.Others;
}
class SelectableFileItem {
  fileType: FileType;
  file: SMH.SpaceFileItemData;
  constructor(file: SMH.SpaceFileItemData) {
    this.fileType = getFileType(file);
    this.file = file;
  }
}
export { SelectableFileItem };
